import { Component, Input, OnInit } from '@angular/core';
import { ChartConfiguration, ChartData, ChartOptions } from 'chart.js';
import * as dayjs from 'dayjs';
import { moneyChartData, moneyChartOptions } from '../../chart-options';
import { BaseResultChartComponent } from '../base-result-chart-component.directive';

@Component({
  selector: 'psc-return-on-investment-chart',
  templateUrl: './return-on-investment-chart.component.html',
})
export class ReturnOnInvestmentChartComponent extends BaseResultChartComponent implements OnInit {

  @Input() advanced: boolean = false;

  moneyChartData: ChartData<'bar'> = moneyChartData();
  moneyChartOptions: ChartOptions<'bar'> = moneyChartOptions();
  moneyChartType: ChartConfiguration<'bar'>["type"] = 'bar';

  override ngOnInit() {
    super.ngOnInit();
    /**
     * t(calculator_result.chart.profitability)
     */
    this.subscribeToLabelTranslation('profitability', this.moneyChartData.datasets[0]);

    this.subs.sink = this.resultChartsService.generateChartImageRequest.ROIGraph.subscribe(
      () => {
        const hiddenChart = this.charts.get(1);

        hiddenChart?.chart?.canvas.toBlob(blob => {
          this.resultChartsService.chartImageGenerated.ROIGraph.next(blob as Blob);
        }, 'image/png');

      },
    );
  }


  setChartData() {
    this.moneyChartData.labels = Array.from({ length: this.solarCalculatorResult.profitability.length }, (_, i) => dayjs().year() + i);
    this.moneyChartData.datasets[0].data = this.solarCalculatorResult.profitability;
    this.updateCharts();
  }

}
